import React from 'react';
import PropTypes from 'prop-types';

export default class GoogleAd extends React.Component {
  render() {
    return (
      <div>
        <ins className={`${this.props.className} adsbygoogle`}
          style={this.props.style} 
          data-adtest="on"
          data-ad-client="ca-pub-3397827005717908"
          data-ad-slot="9073923593"
          data-ad-layout={this.props.layout}
          data-ad-format={this.props.format}
          data-full-width-responsive={this.props.responsive}></ins>

        </div>
    );
  }
};

GoogleAd.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object, // eslint-disable-line
  client: PropTypes.string.isRequired,
  slot: PropTypes.string.isRequired,
  layout: PropTypes.string,
  format: PropTypes.string,
  responsive: PropTypes.string
};

GoogleAd.defaultProps = {
  className: '',
  style: {display: 'block'}, 
  format: 'auto',
  layout: '',
  responsive: 'true'
};


{/* <script async src="//pagead2.googlesyndication.com/pagead/js/adsbygoogle.js"></script>
        <script>
            (adsbygoogle = window.adsbygoogle || []).push({
                google_ad_client: "ca-pub-8988417827627902",
            enable_page_level_ads: true
        }); 
        </script>*/}